import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tag-collapsible"
export default class extends Controller {
  static targets = ['content', 'chevron', 'buttonText']

  connect() {
    console.log('Tag collapsible controller connected')
    // Start in collapsed state
    this.isExpanded = false
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    console.log('Toggling collapsible section')

    if (!this.hasContentTarget) {
      console.error('No content target found')
      return
    }

    this.isExpanded = !this.isExpanded

    if (this.isExpanded) {
      // Expand
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + 'px'

      // Rotate chevron 180 degrees
      if (this.hasChevronTarget) {
        this.chevronTarget.style.transform = 'rotate(180deg)'
      }

      // Update button text
      if (this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = 'Clique para recolher'
      }
    } else {
      // Collapse
      this.contentTarget.style.maxHeight = '0px'

      // Reset chevron rotation
      if (this.hasChevronTarget) {
        this.chevronTarget.style.transform = 'rotate(0deg)'
      }

      // Update button text
      if (this.hasButtonTextTarget) {
        const tagsCount = this.element.querySelector('[data-tags-count]')?.dataset.tagsCount || 0
        if (tagsCount > 0) {
          this.buttonTextTarget.textContent = 'Clique para expandir'
        } else {
          this.buttonTextTarget.textContent = 'Clique para criar categorias'
        }
      }
    }
  }
}
